
export default {
  code: "pl",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Poprzedni",
    next: "Następny",
    today: "Dziś",
    month: "Miesiąc",
    week: "Tydzień",
    day: "Dzień",
    list: "Plan dnia"
  },
  weekLabel: "Tydz",
  allDayText: "Cały dzień",
  eventLimitText: "więcej",
  noEventsMessage: "Brak wydarzeń do wyświetlenia"
};
